import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

interface VigenciaFerias {
  vigenciaFeriasPortalId: number;
  ano: number;
  dataIni: Date;
  dataFim: Date;
}

interface ParametroVigenciaFerias {
  vigenciaFeriasPortalId: number;
  ano: number;
  dataIni: Date;
  dataFim: Date;
  agendamentoDesativado: string;
  qtdDiasLimiteAgendamento: number;
  remarcacaoDesativado: string;
  vigenciaAtiva: boolean;
}

interface SolicitacaoFerias {
  SeguradoId: number;
  FeriasPortalId: number;
  Ano?: number;
  SetorId: number;
  NomeMatricula: string;
  TipoAlteracaoFeriasId: number;
  TipoAlteracaoFerias: string;
  TipoPag1Terco: string;
  TipoPag1TercoTexto?: string;
  DataInsert?: Date;
  PossuiAlteracao?: number;
  UsrLogin: string;
  Periodos: PeriodosFerias[];
  PeriodosFormatadosHtml?: string;
}

interface PeriodosFerias {
  PeriodoFeriasId?: number;
  DataIni: Date;
  DataFim: Date;
  QtdDias?: number;
  TipoPeriodo: string;
  TipoPeriodoTexto?: string;
  PagoComoAbono: boolean;
  PagoComoAbonoTexto?: string;
  Ciente: boolean;
  CienteTexto?: string;
  DataCiencia?: Date;
  StatusPeriodoFeriasId?: number;
  StatusPeriodoFeriasTexto?: string;
  DeferidoPor?: string;
}

interface DialogData {
  usuarioId: number,
  seguradoId: number;
  nomeSegurado: string;
  matriculaSegurado: string;
  Url: string;
}

@Component({
  selector: 'app-ferias',
  templateUrl: './ferias.component.html',
  styleUrls: ['./ferias.component.scss']
})

export class FeriasComponent implements OnInit {

  periodos: any[] = [];
  periodosSelecionados: boolean[] = [];
  periodoIdSelecionado: number = 0;
  proximoIdTemporario: number = 0;

  SeguradoId: number = 0;
  FeriasdId: number = 0;
  VigenciaFeriasPortalId: number = 0;
  TipoOperacaoFerias: number = 0;
  TipoOperacaoPeriodoTexto: string = '';
  TipoOperacaoFeriasTexto: string = '';

  PreechimentoAtivo: boolean = false;
  EdicaoPeriodoSelecionado: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private dialog: MatDialog,
    private dialogFerias: MatDialogRef<FeriasComponent>
  ) {
    this.feriasForm = this.fBuilder.group({
      novoDataIni: [''],
      novoDataFim: [''],
      novoTipo: ['N'],
      novoPagoComoAbono: [false],
      altDataIni: [''],
      altDataFim: [''],
      altTipo: ['N'],
      altPagoComoAbono: [false],
      tipoPagamento: ['', Validators.required]
    });
  }

  Mostrar: boolean = false;
  segurado: string = "";

  exibirBotoes = {
    solicitar: false,
    alterar: false,
    confirmarAlterar: false,
    emitirHistorico: false,
    excluir: false,
    cancelar: true
  };

  @ViewChild('motivoAlteracaoDialog') motivoAlteracaoDialog!: TemplateRef<any>;
  caracteresRestantes = 200;
  motivoAlteracao = '';
  motivoSuspensaoExclusao = '';
  dialogRef!: MatDialogRef<any>;

  anoVigencia: number;
  vigenciasFerias: VigenciaFerias[] = [];
  parametroVigenciaFerias!: ParametroVigenciaFerias;

  formFeriasVisible: boolean = false;

  feriasForm: FormGroup;
  qtdDiasTotal: number = 0;
  possuiPeriodoInvalido: boolean = false;
  ngOnInit() {
    this.CarregarModalFerias();
  }

  CarregarModalFerias() {
    this.Mostrar = true;
    const url = `${this.data.Url}/api/Inicial/GetVigenciasFerias`;

    this.http.get<VigenciaFerias[]>(url).subscribe({
      next: (data) => {
        this.vigenciasFerias = data;
        this.segurado = `${this.data.nomeSegurado} - ${this.data.matriculaSegurado}`;

        if (this.vigenciasFerias.length > 0) {
          this.anoVigencia = this.vigenciasFerias[0].ano;
        } else {
          Swal.fire({
            title: "Atenção!",
            type: "info",
            text: "Não foi encontrada nenhuma vigência ativa para agendamento!"
          });
        }
      },
      error: (err) => {
        alert('Erro ao carregar dados.');
      },
      complete: () => {
        this.Mostrar = false;
        this.formFeriasVisible = false;
      }
    });
  }

  ConsultaDadosFerias(vigencia: VigenciaFerias) {
    this.Mostrar = true;

    this.SeguradoId = this.data.seguradoId;
    this.VigenciaFeriasPortalId = vigencia.vigenciaFeriasPortalId;
    const urlParametrosVigencia = `${this.data.Url}/api/Inicial/GetParametrosVigencia?vigenciaFeriasPortalId=${this.VigenciaFeriasPortalId}`;
    const urlDadosFerias = `${this.data.Url}/api/Inicial/GetSolicitacaoFerias?seguradoId=${this.SeguradoId}&vigenciaFeriasPortalId=${this.VigenciaFeriasPortalId}`;

    this.http.get<any>(urlParametrosVigencia).subscribe({
      next: (parametros) => {
        this.parametroVigenciaFerias = {
          vigenciaFeriasPortalId: parametros.vigenciaFeriasPortalId,
          ano: parametros.ano,
          dataIni: parametros.dataIni,
          dataFim: parametros.dataFim,
          agendamentoDesativado: parametros.agendamentoDesativado,
          qtdDiasLimiteAgendamento: parametros.qtdDiasLimiteAgendamento,
          remarcacaoDesativado: parametros.remarcacaoDesativado,
          vigenciaAtiva: parametros.vigenciaAtiva
        };

        this.http.get<SolicitacaoFerias>(urlDadosFerias).subscribe({
          next: (response) => {
            const ferias = response ? response[0] : null;
            if (ferias) {
              this.periodos = (ferias.Periodos || []).map(p => ({
                periodoFeriasId: p.PeriodoFeriasId,
                dataIni: p.DataIni,
                dataFim: p.DataFim,
                qtdDias: p.QtdDias,
                tipo: p.TipoPeriodo,
                pagoComoAbono: p.PagoComoAbono,
                statusPeriodo: p.StatusPeriodoFeriasTexto + (p.Ciente ? ' - Ciente' + ' (' +this.formatarDataHora(p.DataCiencia) + ')': ''),
              }));
              this.PreechimentoAtivo = this.periodos.length == 0;
              this.periodosSelecionados = this.periodos.map(() => false);
              this.feriasForm.patchValue({
                tipoPagamento: ferias.TipoPag1Terco,
              });
              this.exibirBotoes = {
                ...this.exibirBotoes,
                emitirHistorico: ferias.PossuiAlteracao > 0,
              }
            } else {
              this.periodos = [];
              this.periodosSelecionados = [];
              this.feriasForm.patchValue({
                novoDataIni: '',
                novoDataFim: '',
                novoTipo: 'N',
                novoPagoComoAbono: false,
                altDataIni: '',
                altDataFim: '',
                altTipo: 'N',
                altPagoComoAbono: false,
                tipoPagamento: ''
              });
              this.PreechimentoAtivo = true;
            }

            if ((parametros.agendamentoDesativado === 'S' || !(this.getDateOnly(parametros.dataIni) <= this.getDateOnly(Date()) && this.getDateOnly(parametros.dataFim) >= this.getDateOnly(Date()))) && this.periodos.length == 0){
              Swal.fire({
                title: "Atenção!",
                type: "info",
                text: "Agendamento de férias desativado para este ano vigênte!"
              });
            }
            else if(parametros.remarcacaoDesativado === 'S' && this.periodos.length > 0){
              Swal.fire({
                title: "Atenção!",
                type: "info",
                text: "Alteração de férias de desativada para este ano vigênte!"
              });
              return;
            }

            this.formFeriasVisible = true;
            this.exibirBotoes = {
              ...this.exibirBotoes,
              solicitar: parametros.agendamentoDesativado !== 'S' && (this.getDateOnly(parametros.dataIni) <= this.getDateOnly(Date()) && this.getDateOnly(parametros.dataFim) >= this.getDateOnly(Date())) && this.periodos.length == 0,
              alterar: parametros.remarcacaoDesativado !== 'S' && this.periodos.length > 0,
              confirmarAlterar: this.periodos.length > 0 && this.EdicaoPeriodoSelecionado,
              excluir: this.periodos.length > 0,
            };
          },
          error: (error) => {
            alert('Erro ao carregar os dados. Tente novamente.');
          }
        });
      },
      error: (error) => {
        alert('Erro ao carregar parâmetros da vigência.');
      },
      complete: () => {
        this.formFeriasVisible = true;
        this.Mostrar = false
      }
    });
  }

  //#region Operações grid
  periodoSelecionado(): boolean {
    return this.periodosSelecionados.some(sel => sel);
  }

  apenasUmSelecionado(): boolean {
    const idx = this.periodosSelecionados.findIndex(sel => sel);
    return this.periodosSelecionados.filter(sel => sel).length === 1 && this.periodos[idx].statusPeriodo !== "Em gozo" && this.periodos[idx].statusPeriodo !== "Gozado";
  }

  emGozoSelecionado() {
    const idx = this.periodosSelecionados.findIndex(sel => sel);
    return this.periodosSelecionados.filter(sel => sel).length === 1 && this.periodos[idx].statusPeriodo === "Em gozo";
  }

  deferidoSelecionado() {
    const idx = this.periodosSelecionados.findIndex(sel => sel);
    return this.periodosSelecionados.filter(sel => sel).length === 1 && this.periodos[idx].statusPeriodo.startsWith("Deferido");
  }

  excluirSelecionados() {
    this.TipoOperacaoPeriodoTexto = "A excluir";
    this.periodos = this.periodos.filter((_, i) => !this.periodosSelecionados[i]);
    this.periodosSelecionados = this.periodosSelecionados.filter(sel => false);
  }

  alterarSelecionado() {
    this.TipoOperacaoPeriodoTexto = "A remarcar";
    this.EdicaoPeriodoSelecionado = true;
    const idx = this.periodosSelecionados.findIndex(sel => sel);
    if (idx !== -1) {
      const periodo = this.periodos[idx];
      this.periodoIdSelecionado = periodo.periodoFeriasId;
      this.feriasForm.patchValue({
        altDataIni: this.formatDateForInput(periodo.dataIni),
        altDataFim: this.formatDateForInput(periodo.dataFim),
        altTipo: periodo.tipo,
        altPagoComoAbono: periodo.pagoComoAbono
      });
      this.feriasForm.get('altDataIni').enable();
      this.feriasForm.get('altTipo').enable();
      this.feriasForm.get('altPagoComoAbono').enable();

      this.periodos.splice(idx, 1);
      this.periodosSelecionados.splice(idx, 1);
    }
  }

  interromperSelecionado() {
    this.TipoOperacaoPeriodoTexto = "A interromper";
    this.EdicaoPeriodoSelecionado = true;

    const idx = this.periodosSelecionados.findIndex(sel => sel);
    if (idx !== -1) {
      const periodo = this.periodos[idx];
      this.feriasForm.patchValue({
        altDataIni: this.formatDateForInput(periodo.dataIni),
        altDataFim: this.formatDateForInput(periodo.dataFim),
        altTipo: periodo.tipo,
        altPagoComoAbono: periodo.pagoComoAbono
      });
      this.feriasForm.get('altDataIni').disable();
      this.feriasForm.get('altTipo').disable();
      this.feriasForm.get('altPagoComoAbono').disable();

      this.periodos.splice(idx, 1);
      this.periodosSelecionados.splice(idx, 1);
    }
  }

  declararCiencia(): void {
    const idx = this.periodosSelecionados.findIndex(sel => sel);
    if (idx !== -1) {
      const periodo = this.periodos[idx];
      const periodoId = periodo.periodoFeriasId;
      const urlHistoricoFerias = `${this.data.Url}/api/Inicial/DeclararCienciaDeferimento?periodoFeriasPortalId=${periodoId}`;

      Swal.fire({
        title: "Atenção!",
        text: "Confirma que reconhece o deferimento da sua solicitação de férias?",
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não'
      }).then((result: any) => {
        this.http.post(urlHistoricoFerias, null).subscribe({
          next: (response) => {
            Swal.fire({
              title: "Sucesso!",
              type: "success",
              text: "Ciência do deferimento declarada com sucesso!"
            });
            this.ConsultaDadosFerias(this.vigenciasFerias.find(v => v.vigenciaFeriasPortalId === this.VigenciaFeriasPortalId)!);
          },
          error: (error) => {
            Swal.fire({
              title: "Erro!",
              type: "error",
              text: "Erro ao declarar ciência do deferimento: " + (error.error.message || error.message)
            });
            this.PreechimentoAtivo = false;
          }
        });
      });
    }
  }

  //#endregion

  //#region Operações modal

  confirmarFerias(): void {
    if (this.periodos.length === 0) {
      Swal.fire({
        title: "Atenção!",
        type: "warning",
        text: "Adicione ao menos 1 período para solicitação!"
      });
      return;
    }

    if (this.feriasForm.invalid) {
      Swal.fire({
        title: "Atenção!",
        type: "warning",
        text: "Preencha todos os campos obrigatórios corretamente!"
      });
      return;
    }

    this.ConfirmarSolicitarFerias();
  }

  alterarFerias(): void {
    this.TipoOperacaoFerias = 2;
    this.TipoOperacaoFeriasTexto = 'Alteração';
    this.PreechimentoAtivo = true;

    this.exibirBotoes = {
      solicitar: false,
      alterar: false,
      confirmarAlterar: true,
      emitirHistorico: false,
      excluir: false,
      cancelar: true
    };
  }

  confirmarAlterarFerias(): void {
    if (this.periodos.length === 0) {
      Swal.fire({
        title: "Atenção!",
        type: "warning",
        text: "Adicione ao menos 1 período para alterar a solicitação das férias!"
      });
      return;
    }

    if (this.feriasForm.invalid) {
      Swal.fire({
        title: "Atenção!",
        type: "warning",
        text: "Preencha todos os campos obrigatórios corretamente!"
      });
      return;
    }

    this.dialogRef = this.dialog.open(this.motivoAlteracaoDialog, {
      width: '600px',
      disableClose: true
    });

    this.dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        this.motivoAlteracao = '';
        this.caracteresRestantes = 200;
      }
    });
  }

  emitirHistorico(): void {
    this.Mostrar = true;
    const seguradoId = this.data.seguradoId;
    const vigenciaId = this.parametroVigenciaFerias.vigenciaFeriasPortalId;
    const urlHistoricoFerias = `${this.data.Url}/api/Inicial/EmitirHistoricoFerias?seguradoId=${seguradoId}&vigenciaFeriasPortalId=${vigenciaId}`;

    this.http.get(urlHistoricoFerias, {
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'application/pdf'
      })
    }).subscribe({
      next: (blob) => {
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.target = '_blank';
        a.download = `historico-ferias-${seguradoId}-${vigenciaId}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
      },
      error: (err) => {
        Swal.fire({
          title: "Erro!",
          type: "error",
          text: "Erro ao gerar histórico: " + err.message
        });
      },
      complete: () => {
        this.Mostrar = false
      }
    });
  }

  excluirFerias(): void {
    Swal.fire({
      title: "Atenção!",
      text: "Deseja realmente excluir a solicitação das férias?",
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result: any) => {
      if (result && (result.isConfirmed || result.value === true)) {
        this.TipoOperacaoFerias = 3;
        this.dialogRef = this.dialog.open(this.motivoAlteracaoDialog, {
          width: '600px',
          disableClose: true
        });
        this.dialogRef.afterClosed().subscribe(result => {
          if (!result) {
            this.motivoSuspensaoExclusao = '';
            this.caracteresRestantes = 200;
          }
        });
      }
    });
  }

  cancelar(): void {
    this.dialogFerias.close();
    this.router.navigate(['/inicial']);
  }

  //#endregion

  //#region Metodos

  AdicionarPeriodoGrid() {
    const form = this.feriasForm;

    const dataIniStr = form.get(this.EdicaoPeriodoSelecionado ? 'altDataIni' : 'novoDataIni').value;
    const dataFimStr = form.get(this.EdicaoPeriodoSelecionado ? 'altDataFim' : 'novoDataFim').value;
    const dataIni = this.parseDateLocal(dataIniStr);
    const dataFim = this.parseDateLocal(dataFimStr);
    const tipo = form.get(this.EdicaoPeriodoSelecionado ? 'altTipo' : 'novoTipo').value;
    const pagoComoAbono = form.get(this.EdicaoPeriodoSelecionado ? 'altPagoComoAbono' : 'novoPagoComoAbono').value;

    const hj = new Date();
    let qtdDiasLimite = this.parametroVigenciaFerias.qtdDiasLimiteAgendamento;

    let qtdDiasTotalGrid = this.periodos.reduce((total, p) => total + p.qtdDias, 0);

    if (dataIni instanceof Date && !isNaN(dataIni.getTime()) && dataFim instanceof Date && !isNaN(dataFim.getTime())) {

      const diasAntecedencia = Math.floor((dataIni.getTime() - hj.getTime()) / (1000 * 3600 * 24));
      if (this.TipoOperacaoPeriodoTexto == "A interromper" || diasAntecedencia >= qtdDiasLimite) {

        if (dataFim > dataIni) {

          const datasConcomitantes = this.periodos.some(p => {
            const ini = (p.dataIni instanceof Date) ? p.dataIni : new Date(p.dataIni);
            const fim = (p.dataFim instanceof Date) ? p.dataFim : new Date(p.dataFim);
            return dataIni <= fim && dataFim >= ini;
          });
          if (!datasConcomitantes) {

            const qtdDias = this.calcularDias(dataIni, dataFim);
            if (qtdDiasTotalGrid + qtdDias <= 30) {

              this.proximoIdTemporario--;
              this.periodos.push({
                periodoFeriasId: this.EdicaoPeriodoSelecionado ? this.periodoIdSelecionado : this.proximoIdTemporario,
                dataIni,
                dataFim,
                qtdDias,
                tipo,
                pagoComoAbono: tipo === 'N' ? pagoComoAbono : true,
                statusPeriodo: this.EdicaoPeriodoSelecionado ? this.TipoOperacaoPeriodoTexto : 'A solicitar'
              });
              this.periodosSelecionados.push(false);

              form.patchValue({
                novoDataIni: '',
                novoDataFim: '',
                novoTipo: 'N',
                novoPagoComoAbono: false,
                altDataIni: '',
                altDataFim: '',
                altTipo: 'N',
                altPagoComoAbono: false,
              });
              this.EdicaoPeriodoSelecionado = false;

              this.periodos.sort((a, b) => new Date(a.dataIni).getTime() - new Date(b.dataIni).getTime());
            } else {
              Swal.fire({
                title: "Atenção!",
                type: "warning",
                text: "A soma dos períodos não pode ultrapassar 30 dias!"
              });
            }
          }
          else {
            Swal.fire({
              title: "Atenção!",
              type: "warning",
              text: "O período preechido é concomitante com outro período!"
            });
          }
        }
        else {
          Swal.fire({
            title: "Atenção!",
            type: "warning",
            text: "A \"Data Fim\" deve ser superior a \"Data Início\"!"
          });
        }
      }
      else {
        Swal.fire({
          title: "Atenção!",
          type: "warning",
          text: "A \"Data Início\" do período de férias deve ser informada com pelo menos " + qtdDiasLimite + " dias de antecedência em relação à data atual."
        });
      }
    }
    else {
      Swal.fire({
        title: "Atenção!",
        type: "warning",
        text: "Preencha um período válido!"
      });
    }
  }

  ConfirmarSolicitarFerias(): void {
    this.Mostrar = true
    const formValue = this.feriasForm.value;
    const dadosFerias = {
      SeguradoId: this.data.seguradoId,
      VigenciaFeriasId: this.VigenciaFeriasPortalId,
      UsrIdInsert: this.data.usuarioId,
      Periodos: this.periodos.map(p => ({
        TipoPeriodo: p.tipo,
        DataIni: p.dataIni,
        DataFim: p.dataFim,
        QtdDias: p.qtdDias,
        PagoComoAbono: p.pagoComoAbono,
        StatusPeriodoFeriasId: p.statusPeriodo === 'A remarcar' ? 2 : (p.statusPeriodo === 'A interromper' ? 6 : (p.statusPeriodo === 'A excluir' ? 3 : 1)),
      })),
      TipoPag1Terco: formValue.tipoPagamento,
      TipoOperacao: this.TipoOperacaoFerias === 0 ? 1 : this.TipoOperacaoFerias,
      MotivoAlteracao: this.motivoAlteracao,
    };

    this.http.post(`${this.data.Url}/api/Inicial/SolicitarFerias`, dadosFerias).subscribe({
      next: (response) => {
        Swal.fire({
          title: "Sucesso!",
          type: "success",
          text: "Férias " + (this.TipoOperacaoFerias == 2 ? "alteradas" : (this.TipoOperacaoFerias == 3 ? "excluídas" : "solicitadas")) + " com sucesso!"
        });
        this.dialogFerias.close();
        this.router.navigate(['/inicial']);
      },
      error: (error) => {
        Swal.fire({
          title: "Erro!",
          type: "error",
          text: "Erro ao " + (this.TipoOperacaoFerias == 2 ? "alterar" : (this.TipoOperacaoFerias == 3 ? "excluir" : "solicitar")) + " férias: " + (error.error.message || error.message)
        });
      },
      complete: () => {
        this.Mostrar = false;
        this.PreechimentoAtivo = false;
        if (this.dialogRef) {
          this.dialogRef.close();
        }
      }
    });
  }

  cancelarRemarcarFerias(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  onTextChange(event: any): void {
    this.caracteresRestantes = 200 - event.target.value.length;
  }

  formatarDataHora(data: Date | string | undefined): string {
    if (!data) return '';
    const d = typeof data === 'string' ? new Date(data) : data;
    if (isNaN(d.getTime())) return '';
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  }

  calcularDias(dataIni: Date, dataFim: Date): number {
    const ini = new Date(dataIni);
    const fim = new Date(dataFim);
    return Math.floor((fim.getTime() - ini.getTime()) / (1000 * 3600 * 24)) + 1;
  }

  formatDateForInput(date: Date | string | null): string | null {
    if (!date) return null;

    if (typeof date === 'string') {
      return date.split('T')[0];
    }

    if (date instanceof Date) {
      return date.toISOString().split('T')[0];
    }

    return null;
  }

  disableFormFields() {
    Object.keys(this.feriasForm.controls).forEach(controlName => {
      this.feriasForm.get(controlName).disable();
    });
  }

  enableFormFields() {
    Object.keys(this.feriasForm.controls).forEach(controlName => {
      this.feriasForm.get(controlName).enable();
    });
  }

  getDateOnly(date: Date | string): Date | null {
    if (!date) return null;
    let d: Date;
    if (typeof date === 'string') {
      d = new Date(date);
      if (isNaN(d.getTime())) return null;
    } else {
      d = date;
    }
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  parseDateLocal(dateStr: string): Date | null {
    if (!dateStr) return null;
    const [year, month, day] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day, 12, 0, 0);
  }

  onAnoVigenciaChange(event: any) {
    const vigenciaSelecionada = this.vigenciasFerias.find(
      v => v.ano === event.value
    );

    if (vigenciaSelecionada) {
      this.ConsultaDadosFerias(vigenciaSelecionada);
    }
  }

  //#endregion
}
